export const linkApiPath = {
  getLinkCuration: `/v2/link/curation`,
  getLinkCoupon: (couponNo: number) => `/v2/link/coupon/${couponNo}`,
  getCuratorShopLink: `/v2/link/curator/shop`,
} as const;
